import { type IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
    faAirConditioner,
    faAppleWhole,
    faBaby,
    faBabyCarriage,
    faBadgeCheck,
    faBath,
    faBell,
    faBellConcierge,
    faBorderAll,
    faBottleWater,
    faBowlFood,
    faBowlingBall,
    faBox,
    faBreadSlice,
    faBurger,
    faBus,
    faCalendar,
    faCarRear,
    faCartShopping,
    faChair,
    faChampagneGlasses,
    faChildReaching,
    faCircleParking,
    faClothesHanger,
    faCompactDisc,
    faComputer,
    faCopy,
    faCouch,
    faCreditCard,
    faDolly,
    faDumbbell,
    faEgg,
    faElevator,
    faFan,
    faFax,
    faFilm,
    faFire,
    faFireBurner,
    faFireExtinguisher,
    faFlagSwallowtail,
    faFutbol,
    faGamepadModern,
    faGears,
    faHandSparkles,
    faHeat,
    faHotTubPerson,
    faIdCard,
    faJar,
    faKitchenSet,
    faLeaf,
    faLightbulb,
    faMapLocationDot,
    faMicrowave,
    faMoneyBillTransfer,
    faMosque,
    faMugHot,
    faMugSaucer,
    faMusic,
    faNewspaper,
    faPeopleGroup,
    faPeopleRoof,
    faPersonRunning,
    faPersonWalking,
    faPhone,
    faPhoneFlip,
    faPhoneOffice,
    faPinata,
    faPlane,
    faPlateUtensils,
    faPool8Ball,
    faPowerOff,
    faPrint,
    faPumpSoap,
    faPuzzlePiece,
    faRefrigerator,
    faRing,
    faRouter,
    faRug,
    faSatelliteDish,
    faScissors,
    faShirt,
    faShoePrints,
    faShuttleVan,
    faSink,
    faSmoking,
    faSnowflake,
    faSoap,
    faSpa,
    faStore,
    faSuitcase,
    faTable,
    faTableTennisPaddleBall,
    faTaxi,
    faTemperatureHalf,
    faTemperatureHigh,
    faTent,
    faTheaterMasks,
    faTicket,
    faToilet,
    faTooth,
    faTree,
    faTreeDeciduous,
    faTv,
    faUmbrellaBeach,
    faUserHeadset,
    faUsers,
    faUtensils,
    faVanShuttle,
    faVault,
    faVolumeHigh,
    faVolumeXmark,
    faWashingMachine,
    faWater,
    faWaterLadder,
    faWheelchair,
    faWifi,
    faWindowMaximize,
    faWineGlass,
} from '@fortawesome/pro-regular-svg-icons';

export const amenityIconMap: Record<string, IconDefinition> = {
    f2e7: faUtensils,
    f0eb: faLightbulb,
    f7d8: faToilet,
    f09d: faCreditCard,
    e59d: faChildReaching,
    f26c: faTv,
    e2c5: faVault,
    f095: faPhone,
    f466: faBox,
    f4b8: faCouch,
    f2c2: faIdCard,
    f863: faFan,
    e026: faRefrigerator,
    e5d7: faRug,
    f7b6: faMugHot,
    f2cd: faBath,
    f54b: faShoePrints,
    f769: faTemperatureHigh,
    f2dc: faSnowflake,
    f4e3: faWineGlass,
    e5dc: faClothesHanger,
    f6a9: faVolumeXmark,
    e4c6: faBottleWater,
    f2d0: faWindowMaximize,
    f134: faFireExtinguisher,
    f011: faPowerOff,
    f0ce: faTable,
    f77c: faBaby,
    f593: faHotTubPerson,
    f84c: faBorderAll,
    e4c7: faBowlFood,
    e51a: faKitchenSet,
    e516: faJar,
    e4f1: faFireBurner,
    f06d: faFire,
    f436: faBowlingBall,
    f1ea: faNewspaper,
    f6c0: faChair,
    f085: faGears,
    f70c: faPersonRunning,
    e4e5: faComputer,
    e06b: faPumpSoap,
    e06e: faSoap,
    f008: faFilm,
    f5c9: faTooth,
    f0f3: faBell,
    f5d1: faAppleWhole,
    f5b6: faShuttleVan,
    f7c0: faSatelliteDish,
    f207: faBus,
    e01b: faMicrowave,
    f7fb: faEgg,
    f2c9: faTemperatureHalf,
    f51f: faCompactDisc,
    f898: faWashingMachine,
    f0f2: faSuitcase,
    f0c5: faCopy,
    f0f4: faMugSaucer,
    f5c5: faWaterLadder,
    f554: faPersonWalking,
    f1ba: faTaxi,
    f678: faMosque,
    f5a0: faMapLocationDot,
    f1ac: faFax,
    f472: faDolly,
    f02f: faPrint,
    f805: faBurger,
    f1bb: faTree,
    f5d0: faHandSparkles,
    f1e3: faFutbol,
    e533: faPeopleGroup,
    f0c0: faUsers,
    f630: faTheaterMasks,
    f79f: faChampagneGlasses,
    e537: faPeopleRoof,
    f54e: faStore,
    e528: faMoneyBillTransfer,
    f001: faMusic,
    f06c: faLeaf,
    f773: faWater,
    f5ca: faUmbrellaBeach,
    f0c4: faScissors,
    f5bb: faSpa,
    f48d: faSmoking,
    e57d: faTent,
    f70b: faRing,
    f562: faBellConcierge,
    f072: faPlane,
    f45d: faTableTennisPaddleBall,
    f028: faVolumeHigh,
    e9c2: faCalendar,
    e998: faGamepadModern,
    e98a: faPlateUtensils,
    e993: faWaterLadder,
    e9a2: faWheelchair,
    e982: faPinata,
    e97e: faBabyCarriage,
    e984: faBabyCarriage,
    e992: faSpa,
    e991: faCouch,
    e9a1: faHotTubPerson,
    e983: faSink,
    e9a5: faPlane,
    e9aa: faBadgeCheck,
    e997: faShirt,
    e995: faPhoneOffice,
    e986: faMugHot,
    e980: faPool8Ball,
    e9a8: faTreeDeciduous,
    e994: faTaxi,
    e98b: faPhoneFlip,
    e981: faUserHeadset,
    e985: faVanShuttle,
    e9a9: faBreadSlice,
    e9a3: faDumbbell,
    e98e: faRouter,
    e988: faFlagSwallowtail,
    e98c: faPrint,
    e9a6: faCarRear,
    e98d: faPuzzlePiece,
    e98f: faCartShopping,
    e996: faTicket,
    e987: faElevator,
    e9a7: faHeat,
    e9ab: faCircleParking,
    e999: faWifi,
    e97d: faAirConditioner,
    e9a4: faWashingMachine,
};
